export default "__VITE_ASSET__CznatU0A__"